import { Component } from "@angular/core";

@Component({
	selector: "caass-Visitor",
	templateUrl: "./report-inbox-main.component.html",
})
export class ReportInboxMainComponent {}
